<p>Choose who belongs to this team. Unchecking a current member removes only their membership in this team.</p>
<p aria-live="polite"><strong>{{ state.addMatching ? 'Matching additions checked on Save' : state.selection.size + ' additions' }} · {{ state.removals.size }} removals</strong>. Other members stay unchanged.</p>
<section aria-label="Team filters">
  <h3>Team filters</h3>
  @if (state.criteria.loading) {
    <p role="status">Loading team filters…</p>
  }
  @if (state.criteria.error) {
    <p role="alert">{{ state.criteria.error }} {{ state.rulesChanged ? 'Your filter changes are still unsaved.' : 'You can still choose members individually.' }}</p>
  }
  @if (state.criteria.error) {
    <button mat-button type="button" [disabled]="disabled || state.criteria.loading" (click)="state.criteria.open(state.companyId, state.context?.snapshot?.id || '', state.teamId)">Retry team filters</button>
  }
  @if (state.criteria.saved) {
    @if (!state.rulesEditing) {
      @if (!state.criteria.saved.criteria) {
        <p>No team filters saved.</p>
      }
      @if (state.criteria.saved.criteria?.allEligible) {
        <p>All eligible employees</p>
      }
      <mat-chip-set aria-label="Team filters">@for (rule of state.criteria.saved.criteria?.rules; track rule) {
        @for (value of rule.values; track value) {
          <mat-chip>{{ state.criteria.labels[rule.field] }}: {{ value }}</mat-chip>
        }
      }</mat-chip-set>
      <button mat-stroked-button type="button" [disabled]="disabled" (click)="state.editRules()">{{ state.criteria.saved.criteria ? 'Edit team filters' : 'Set team filters' }}</button>
    }
    @if (state.rulesEditing) {
      <app-payroll-workforce-criteria [state]="state.criteria" [editorOnly]="true" [disabled]="disabled"></app-payroll-workforce-criteria>
      <button mat-button type="button" [disabled]="disabled" (click)="state.discardRuleChanges()">Discard filter changes</button>
      <p>Filter changes are saved with this dialog. They do not remove members or automatically select additions.</p>
    }
    <mat-radio-group [(ngModel)]="state.addMatching" [disabled]="disabled" aria-label="How to add employees">
      <mat-radio-button [value]="false">Choose additions individually</mat-radio-button>
      <mat-radio-button [value]="true" [disabled]="disabled || !state.criteria.valid">Add all eligible matches of team filters</mat-radio-button>
    </mat-radio-group>
    @if (state.addMatching) {
      <p>Save adds newly matching employees and applies only your explicit removals. Previously removed members remain excluded. Individual addition selections are not applied in this mode.</p>
    }
    @if (state.rulesChanged) {
      <p role="status">Team filters have unsaved changes.</p>
    }
  }
</section>
@if (state.error) {
  <p role="alert">{{ state.error }}</p>
}
@if (state.notice) {
  <p role="status">{{ state.notice }}</p>
}
@if (state.removals.size) {
  <details><summary>Review removals</summary>
  <mat-chip-set>@for (entry of state.removals | keyvalue; track entry) {
    <mat-chip [removable]="!disabled" (removed)="state.removals.delete(entry.key)">
      {{ entry.value }}@if (!disabled) {
      <button matChipRemove [attr.aria-label]="'Keep ' + entry.value"><mat-icon>cancel</mat-icon></button>
    }
  </mat-chip>
}</mat-chip-set>
</details>
}
<mat-tab-group>
  <mat-tab label="Current members">
    <form (ngSubmit)="state.loadMembers(true)">
      <mat-form-field appearance="outline"><mat-label>Last name or email starts with</mat-label><input matInput name="memberSearch" [(ngModel)]="state.memberSearch" maxlength="191" [disabled]="disabled"></mat-form-field>
      <button mat-stroked-button type="submit" [disabled]="disabled || state.membersLoading">Search</button>
    </form>
    @if (state.membersLoading) {
      <p role="status">Loading members…</p>
    }
    @if (state.membersError) {
      <p role="alert">{{ state.membersError }}</p>
    }
    @if (state.membersError) {
      <button mat-button type="button" (click)="state.loadMembers()" [disabled]="disabled || state.membersLoading">Retry</button>
    }
    @if (!state.membersLoading && !state.membersError && !state.members.length) {
      <p>No current members match this search.</p>
    }
    @for (member of state.members; track member) {
      <div class="member-row">
        <mat-checkbox [checked]="!state.removals.has(member.memberId)" [disabled]="disabled || !!member.reason" (change)="state.toggleMember(member)" [aria-label]="'Keep ' + (member.firstName || member.email || 'member') + ' on team'"></mat-checkbox>
        <div>{{ member.firstName }} {{ member.lastName }}<small>{{ member.email }}</small>
        @if (!member.linked) {
          <small>Membership has no linked account.</small>
        }
        @if (member.reason) {
          <small>Protected member or removal already in progress.</small>
        }
      </div>
    </div>
  }
  <nav aria-label="Current member pages">
    <button mat-stroked-button type="button" (click)="state.previousMembers()" [disabled]="disabled || state.membersLoading || !state.canGoBackMembers">Previous</button>
    <button mat-stroked-button type="button" (click)="state.nextMembers()" [disabled]="disabled || state.membersLoading || !state.nextMemberId">Next</button>
  </nav>
</mat-tab>
<mat-tab label="All employees"><app-payroll-workforce-browse [state]="state" [selectionOnly]="true" [memberEditing]="true" [matchingMode]="state.addMatching" [disabled]="disabled"></app-payroll-workforce-browse></mat-tab>
</mat-tab-group>
